export default "__VITE_ASSET__DK77Oyqc__"